import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiURL:string = environment.apiHost;

  constructor(private router:Router, private http: HttpClient) { }

  private buildHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken');
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  login(username: string, password: string): Promise<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = this.apiURL + 'login';
    return new Promise((resolve, reject) => {
      this.http.post(url, { username, password }, httpOptions).subscribe(
        res => resolve(res),
        error => reject(error)
      );
    });
  }

  send(apiName,data){
    const httpOptions = { headers: this.buildHeaders() };
    let listnerAPI = "";
    switch(apiName){
      case "findDb":
       listnerAPI = "get-data"
      break;
      case "insertDb":
      listnerAPI = "insert-data"

      break;
      case "updateDb":
      listnerAPI = "update-data"

      break;
      case "deleteDb":
      listnerAPI = "delete-data"

      break;
      case "query":
      listnerAPI = "query"

      break;

    }

    let url = this.apiURL+listnerAPI;
    return new Promise((resolve,reject)=>{
      this.http.post(url,data,httpOptions).subscribe(res=>{

        resolve(res);
      },error=>{reject(error);})
    });
  }

  getLoggedUserInfo(){
    return new Promise((resolve)=>{

      this.send('findDb',{
        table:"users as U",
        fields:["U.*","R.*", "B.*", "U.id as id","B.name as business_name","U.mobile","B.mobile as business_mobile","'******' as password"],
        joins:[{
          type:'left',
          table:'roles as R',
          conditions:['R.id = U.role_id']
        },{
          type:'left',
          table:'businesses as B',
          conditions:['B.id = U.business_id']
        }],
        conditions:[{
          "U.role_id":localStorage.getItem('roleId'),
          "U.id":localStorage.getItem('userId'),
          "U.business_id":localStorage.getItem('businessId')
        }]
      }).then((loggedUserInfo:any)=>{
        // console.log('logg==',loggedUserInfo)
          resolve(loggedUserInfo)
      })
    })
  }

  getRoute(level,link){
    if(level == 1){
      return '/admin'+link;
    }else if(level > 1){
      return '/user'+link;
    }
  }



  logOut(){
    localStorage.clear();
    localStorage.setItem("logOutStatus",'1')
    this.router.navigate(['/login']);
  }

}
